import { FormikProps } from "formik";
import { useContext } from "react";
import { ChildLicenseFilter } from "../../../../../generated/data-contracts";
import { FormikUtils } from "../../../../../utils";
import { isMobileView } from "../../../../shared/appStates/appStates";
import { FilterActions } from "../../../../shared/components/form";
import { AvisInputTextWithFilterType } from "../../../../shared/components/inputs";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface IChildLicensesFilterFormProps {
  bag: FormikProps<ChildLicenseFilter>;
  loading: boolean;
  filtered: boolean;
}

export function ChildLicensesFilterForm(
  props: Readonly<IChildLicensesFilterFormProps>,
) {
  const { bag, loading, filtered } = props;
  const { res } = useContext(AvisContext);
  const classNameSecondColumn = isMobileView.value ? "col-6" : "col-4";

  return (
    <>
      <div className="row">
        <AvisInputTextWithFilterType<ChildLicenseFilter>
          className={classNameSecondColumn}
          label={res("licensees_License_label_ObjectName")}
          bag={bag}
          bagField="licenseObjectName"
          bagFieldFilterType="licenseObjectNameFilterType"
          disabled={loading}
          minLength={2}
          maxLength={200}
          onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, bag.submitForm)}
        />
      </div>
      <FilterActions
        bag={bag}
        loading={loading}
        res={res}
        filtered={filtered}
      />
    </>
  );
}
